<form id="form" [formGroup]="form" (ngSubmit)="submitForm()" *ngIf="form">
	<div class="row my-4">
		<div *ngIf="!isAddForm" class="col-12 col-lg-12">
			<label for="statutInt" class="form-label fw-bold"
				>Type de prestation</label
			>
			<span class="form-control-plaintext">{{
				PrestationTypeStringEnum[prestation.typePrestation]
			}}</span>
		</div>
	</div>
	<div *ngIf="!isAddForm" class="row my-4">
		<div class="col-12 col-lg">
			<label for="statut" class="form-label fw-bold"
				>Statut</label
			>
			<select
				required
				*ngIf="!this.isAddForm"
				id="statut"
				class="form-select"
				name="statut"
				formControlName="statut"
				(ngModelChange)="onStatutChanged()"
				aria-label="Sélectionner un statut"
				
			>
			<option [value]="PrestationStatutEnum.OUVERT" [disabled]="!showStatutOUVERT">Ouvert</option>
			<option [value]="PrestationStatutEnum.COURS" [disabled]="!showStatutENCOURS">En cours</option>
			<option [value]="PrestationStatutEnum.ANNULE" [disabled]="!showStatutANNULE">Annulé</option>
			<option [value]="PrestationStatutEnum.CLOT" [disabled]="!showStatutCLOT">Clôturé</option>
			</select>
		</div>
	</div>
	<div *ngIf="!isAddForm && this.showFieldNatureAbandon" class="row my-4">
		<div class="col-12 col-lg">
			<label for="natureAbandon" class="form-label fw-bold"
				>Motif de classement</label
			>
			<select
				*ngIf="!this.isAddForm"
				id="natureAbandon"
				class="form-select"
				name="natureAbandon"
				formControlName="natureAbandon"
				(ngModelChange)="shouldCreateModuleSP()"
				
			>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON1">{{NatureAbandonStringEnum.NATABANDON1}}</option>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON2">{{NatureAbandonStringEnum.NATABANDON2}}</option>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON3">{{NatureAbandonStringEnum.NATABANDON3}}</option>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON4">{{NatureAbandonStringEnum.NATABANDON4}}</option>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON5">{{NatureAbandonStringEnum.NATABANDON5}}</option>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON6">{{NatureAbandonStringEnum.NATABANDON6}}</option>
			<option *ngIf="isSelectedStatutANNULE" [value]="NatureAbandonEnum.NATABANDON7">{{NatureAbandonStringEnum.NATABANDON7}}</option>
			<option *ngIf="isSelectedStatutCLOT" [value]="NatureAbandonEnum.NATABANDON8">{{NatureAbandonStringEnum.NATABANDON8}}</option>
			<option *ngIf="isSelectedStatutCLOT" [value]="NatureAbandonEnum.NATABANDON9">{{NatureAbandonStringEnum.NATABANDON9}}</option>
			<option *ngIf="isSelectedStatutCLOT" [value]="NatureAbandonEnum.NATABANDON10">{{NatureAbandonStringEnum.NATABANDON10}}</option>
			<option *ngIf="isSelectedStatutCLOT" [value]="NatureAbandonEnum.NATABANDON11">{{NatureAbandonStringEnum.NATABANDON11}}</option>	
		</select>
		</div>
	</div>
	<div *ngIf="this.showFieldChoixIntervenantSP" class="row my-4">
		<div class="col-12 col-lg">
			<label for="intervenantModule" class="form-label fw-bold"
				>Intervenant pour le suivi des préconisations</label
			>
			<select
				id="intervenantModule"
				class="form-select"
				name="intervenantModule"
				formControlName="intervenantModule"
				aria-label="Sélectionner un intervenant"
				>
				<option *ngFor="let intervenantModule of listIntervenant |  orderBy:'lastName'" value="{{ intervenantModule.id }}">
					{{ intervenantModule.lastName + ' ' +intervenantModule.firstName}}   | 
					<span
							*ngFor="let exp of intervenantModule.expertises; let ilast = last"
							class="me-1"
						>
							{{ exp && ' ' + exp.name }}{{ exp && (ilast ? '' : ',') }}
						</span>
				</option>
			</select>
		</div>
	</div>
	<div *ngIf="!isAddForm && this.showFieldNatureAbandon" class="row my-4">
		<div *ngIf="form.contains('commentaireAbandon')" class="col-12 col-lg">
			<label for="commentaireAbandon" class="form-label fw-bold"
				>Commentaire relatif au classement</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorCommentaireAbandon"> </ngx-editor-menu>
				<ngx-editor [editor]="editorCommentaireAbandon" formControlName="commentaireAbandon" [outputFormat]="'html'"></ngx-editor>
			</div>
		</div>
	</div>
	<div *ngIf="isAddForm" class="row my-4">
		<div class="col-12 col-lg">
			<label for="typePrestation" class="form-label fw-bold"
				>Type de prestation</label
			>
			<select
				required
				*ngIf="this.isAddForm"
				id="typePrestation"
				class="form-select"
				name="typePrestation"
				formControlName="typePrestation"
				aria-label="Sélectionner un type"
				[ngClass]="{
					'is-invalid': typePrestation.invalid,
					'is-valid': typePrestation.dirty && typePrestation.valid
				}"
				(change)="togglePrestationTypeSelected()"
			>
				<option [value]="PrestationTypeEnum.QD">QUALIFICATION DE LA DEMANDE</option>
				<option [value]="PrestationTypeEnum.AS">ANALYSE DE LA SITUATION</option>
				<option [value]="PrestationTypeEnum.AC">ANALYSE DES CAPACITES</option>
				<option [value]="PrestationTypeEnum.EAP">EVALUATION APPROFONDIE AVEC PRECONISATIONS</option>
				<option [value]="PrestationTypeEnum.CAMEO">CONSEIL ET APPUI A LA MISE EN OEUVRE</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('numeroCommande')" class="col-12 col-lg">
			<label for="numeroCommande" class="form-label fw-bold"
				>Numéro de la demande</label
			>
			<input
				id="numeroCommande"
				class="form-control"
				formControlName="numeroCommande"
				[readonly] = "!this.isQDSelected"
			/>
		</div>
	</div>

	<div *ngIf="this.isQDSelected" class="row my-4">
		<div *ngIf="form.contains('dateDepot')" class="col-12 col-lg">
			<label for="dateDepot" class="form-label fw-bold"
				>Date de dépôt</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateDepot"
				name="dateDepot"
				formControlName="dateDepot"
				[ngClass]="{
					'is-invalid': dateDepot.invalid,
					'is-valid': dateDepot.dirty && dateDepot.valid
				}"
			/>
		</div>
	</div>

	<div *ngIf="!this.isQDSelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="qualification" class="form-label fw-bold"
				>Demande de qualification associée</label
			>
			<select
				id="qualiffication"
				class="form-select"
				name="qualification"
				formControlName="idQualification"
				aria-label="Sélectionner une situation"
				(change)="onQualificationSelected()"
				>
				<option *ngFor="let qualification of listQualification |  orderBy:'numeroCommande'" value="{{ qualification.id }}">
					{{qualification.numeroCommande + '  |  ' }}
					{{'Statut : ' + PrestationStatutStringEnum[qualification.statut]  + '  |  ' + 'Date de démarrage : '}} 
					{{qualification.dateDebut | date: 'dd/MM/yy HH:mm'}}  
					{{'Bénéficiaire : ' + qualification.beneficiaire?.firstName + ' ' +qualification.beneficiaire?.lastName + '  |  '}}
					{{'Intervenant : ' + qualification.intervenant?.firstName + ' ' +qualification.intervenant?.lastName}}
				</option>
			</select>
		</div>
	</div>
	<div class="alert alert-danger alert-dismissible fade show"
			profile="alert"
			*ngIf="showErrorModuleAlreadyCreated"
	>
		Ce module est déjà créé pour la demande de qualification sélectionnée
	</div>

	<!-- <div class="row my-4" *ngIf="!this.isIntervenant">
		<div class="col-12 col-lg">
			<label for="bonCommande" class="form-label fw-bold"
				>Bon de commande</label
			>
			<select
				id="bonCommande"
				class="form-select"
				name="bonCommande"
				formControlName="bonCommande"
				aria-label="Sélectionner un bonCommande"
				[disabled] = "!this.isQDSelected"
				>
				<option *ngFor="let bonCommande of listBonCommande" value="{{ bonCommande.id }}">
					{{ bonCommande.marche + ' ' + bonCommande.description + ' '}}
					{{bonCommande.dateDebut | date: 'dd/MM/yy'}} - 
					{{bonCommande.dateFin | date: 'dd/MM/yy'}}
				</option>
			</select>
		</div>
	</div>
	<div class="alert alert-danger alert-dismissible fade show"
			profile="alert"
			*ngIf="showErrorDatesNotBetweenBdc"
	>
		Les dates choisies ne sont pas compatibles avec le bon de commande sélectionné
	</div> -->

	<!-- <div *ngIf="!isAddForm && this.isQDSelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="etatQualification" class="form-label fw-bold"
				>Etat de qualification</label
			>
			<select
				id="etatQualification"
				class="form-select"
				name="etatQualification"
				formControlName="etatQualification"
				aria-label="Sélectionner un état"
				[ngClass]="{
					'is-invalid': etatQualification.invalid,
					'is-valid': etatQualification.dirty && etatQualification.valid
				}"
				(change)="toggleEtatQualificationSelected()"
			>
				<option [value]="QualificationEtatEnum.BROUILLON">Brouillon</option>
				<option [value]="QualificationEtatEnum.ENCOURS">En cours</option>
				<option [value]="QualificationEtatEnum.PRISENCHARGE">Pris en charge</option>
				<option [value]="QualificationEtatEnum.REFUSE">Refusé</option>
			</select>
		</div>
	</div> -->

	<div *ngIf="this.isQDSelected" class="row my-4">
		<div *ngIf="form.contains('raison')" class="col-12 col-lg">
			<label for="raison" class="form-label fw-bold"
				>Détails du besoin</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorRaison"> </ngx-editor-menu>
				<ngx-editor [editor]="editorRaison" formControlName="raison"></ngx-editor>
			</div>
		</div>
	</div>
	<div *ngIf="this.isQDSelected" class="row my-4">
		<div *ngIf="form.contains('imperatifs')" class="col-12 col-lg">
			<label for="imperatifs" class="form-label fw-bold"
				>Impératifs à prendre en compte</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorImperatifs"> </ngx-editor-menu>
				<ngx-editor [editor]="editorImperatifs" formControlName="imperatifs"></ngx-editor>
			</div>
		</div>
	</div>
	<div *ngIf="this.isQDSelected" class="row my-4">
		<div *ngIf="form.contains('metiersCibles')" class="col-12 col-lg">
			<label for="metiersCibles" class="form-label fw-bold"
				>Le ou les métier(s) visé(s)</label
			>
			<div class="NgxEditor__Wrapper">
				<ngx-editor-menu [editor]="editorMetiersCibles"> </ngx-editor-menu>
				<ngx-editor [editor]="editorMetiersCibles" formControlName="metiersCibles"></ngx-editor>
			</div>
		</div>
	</div>
	<div *ngIf="isAddForm && !isIntervenant" class="row my-4">
		<div class="col-12 col-lg">
		  <label for="beneficiaire" class="form-label fw-bold">Bénéficiaire</label>
		  <input type="hidden" formControlName="beneficiaire" />
		  <input
			type="text"
			id="beneficiaire"
			class="form-control"
			placeholder="Rechercher un bénéficiaire"
			[formControl]="beneficiaireInput"
			[ngClass]="{
				'is-invalid': beneficiaire.invalid,
				'is-valid': beneficiaire.dirty && beneficiaire.valid
			}"
			autocomplete="off"
		  />
	  
		  <ul class="list-group mt-1" *ngIf="listBeneficiaireInput.length > 0 && beneficiaireInput.value">
			<li
			  class="list-group-item"
			  *ngFor="let b of listBeneficiaireInput"
			  (click)="selectBeneficiaire(b)"
			  style="cursor: pointer"
			>
			  {{ b.lastName }} {{ b.firstName }}
			</li>
		  </ul>
		</div>
	</div>
	<div *ngIf="isAddForm && isIntervenant" class="row my-4">
		<div class="col-12 col-lg">
			<label for="beneficiaire" class="form-label fw-bold"
				>Bénéficiaire</label
			>
			<select
				required
				id="beneficiaire"
				class="form-select"
				name="beneficiaire"
				formControlName="beneficiaire"
				aria-label="Sélectionner un bénéficiaire"
				(change)="onBeneficiciareChanged()"
				[ngClass]="{
					'is-invalid': beneficiaire.invalid,
					'is-valid': beneficiaire.dirty && beneficiaire.valid
				}"
				>
				<option *ngFor="let beneficiaire of listBeneficiaire |  orderBy:'lastName'" value="{{ beneficiaire.id }}">
					{{ beneficiaire.lastName +' ' + beneficiaire.firstName}}
				</option>
			</select>
		</div>
	</div>
	<div *ngIf="!isAddForm" class="row my-4">
		<div class="col-12 col-lg-12">
			<label class="form-label fw-bold"
				>Bénéficiaire</label
			>
			<span class="form-control-plaintext">{{ prestation.beneficiaire.lastName +' ' + prestation.beneficiaire.firstName}}</span>
		</div>
	</div>

	<div *ngIf="this.showChefFileBoolInput" class="row my-4">
		<div class="col-12 col-lg">
			<div
				class="form-check form-switch ms-2"
			>
				<input
					class="form-check-input theme-main-border-color"
					type="checkbox"
					id="showServiceChefFile"
					formControlName="showServiceChefFile"
					[ngClass]="{
						'theme-main-color-check': showServiceChefFile.value
					}"
					(change)="onCheckServiceChefFileChanged($event)"
				/>
				<label class="form-check-label text-dark" for="showServiceChefFile"
					>Chef de file / Mobilisation d’un autre appui spécifique</label
				>
			</div>
		</div>
	</div>
	<div *ngIf="this.showChefFileServiceListInput" class="row my-4">
		<div class="col-12 col-lg">
			<label for="serviceChefFile" class="form-label fw-bold"
				>Service chef de file</label
			>
			<select
				id="serviceChefFile"
				class="form-select"
				name="serviceChefFile"
				formControlName="serviceChefFile"
				aria-label="Sélectionner un serviceChefFile"
				>
				<option *ngFor="let serviceChefFile of listServiceChefFile" value="{{ serviceChefFile.id }}">
					{{ serviceChefFile.name }}
				</option>
			</select>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg-6">
			<label for="prescripteur" class="form-label fw-bold"
				>Prescripteur</label
			>
			<select
				id="prescripteur"
				class="form-select"
				name="prescripteur"
				formControlName="prescripteur"
				aria-label="Sélectionner un prescripteur"
				(change)="onPrescripteurChanged()"
				>
				<option *ngFor="let prescripteur of listPrescripteur |  orderBy:'nomStructure'" value="{{ prescripteur.id }}">
					{{ prescripteur.nomStructure}}
				</option>
			</select>
		</div>
		<div class="col-12 col-lg-6">
			<label for="prescripteurContact" class="form-label fw-bold"
				>Contact prescripteur</label
			>
			<select
				id="prescripteurContact"
				class="form-select"
				name="prescripteurContact"
				formControlName="prescripteurContact"
				aria-label="Sélectionner un prescripteur"
				>
				<option *ngFor="let prescripteurContact of listPrescripteurContact |  orderBy:'lastName'" value="{{ prescripteurContact.id }}">
					{{ prescripteurContact.lastName + ' ' + prescripteurContact.firstName + ' | ' + prescripteurContact.fonction + ' | ' + prescripteurContact.telephonePortable}}
				</option>
			</select>
		</div>
	</div>

	<div *ngIf="this.isQDSelected" class="row my-4">
		<div class="col-12 col-lg">
			<label for="statutBeneficiaire" class="form-label fw-bold"
				>Statut de bénéficiaire</label
			>
			<select
				id="statutBeneficiaire"
				class="form-select"
				name="statutBeneficiaire"
				formControlName="statutBeneficiaire"
				aria-label="Sélectionner un type"
				(change)="onStatutBeneficiciareChanged()"
			>
				<!-- <option [value]="StatutBeneficiaireEnum.DE">Demandeur d'emploi</option> -->
				<option [value]="StatutBeneficiaireEnum.EEPUB">En emploi public</option>
				<option [value]="StatutBeneficiaireEnum.EEPRIV">En emploi privé</option>
				<option [value]="StatutBeneficiaireEnum.EF">Vers l'emploi</option>
			</select>
		</div>
	</div>

	<div *ngIf="this.isQDSelected" class="row my-4">
		<div class="col-12 col-lg-6">
			<label for="situation" class="form-label fw-bold"
				>Situation</label
			>
			<select
				id="situation"
				class="form-select"
				name="situation"
				formControlName="situation"
				aria-label="Sélectionner une situation"
				>
				<option *ngFor="let situation of listSituation" value="{{ situation.id }}">
					{{ situation.name }}
				</option>
			</select>
		</div>
		<!-- <div class="col-12 col-lg">
			<label for="origineDemande" class="form-label fw-bold"
				>Origine de la demande</label
			>
			<select
				id="origineDemande"
				class="form-select"
				name="origineDemande"
				formControlName="origineDemande"
				>
				<option *ngFor="let origineDemande of listOrigineDemande" value="{{ origineDemande.id }}">
					{{ origineDemande.name }}
				</option>
			</select>
		</div> -->
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Calendrier des interventions</span>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dateDebut')" class="col-12 col-lg">
			<label for="dateDebut" class="form-label fw-bold"
				>Date de démarrage</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateDebut"
				name="dateDebut"
				formControlName="dateDebut"
				(ngModelChange)="startDateChanged()"
				[ngClass]="{
					'is-invalid': dateDebut.invalid,
					'is-valid': dateDebut.dirty && dateDebut.valid
				}"
			/>
		</div>
		<div *ngIf="form.contains('dateLimite')" class="col-12 col-lg-6">
			<label for="dateLimite" class="form-label fw-bold"
				>Date de limite d'exécution</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateLimite"
				name="dateLimite"
				formControlName="dateLimite"
				[ngClass]="{
					'is-invalid': dateLimite.invalid,
					'is-valid': dateLimite.dirty && dateLimite.valid
				}"
			/>
		</div>
	</div>

	<div class="row my-4" *ngIf="!this.isSPSelected">
		<div *ngIf="form.contains('dateFin')" class="col-12 col-lg-6">
			<label for="dateFin" class="form-label fw-bold"
				>Date de fin</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateFin"
				name="dateFin"
				formControlName="dateFin"
				[ngClass]="{
					'is-invalid': dateFin.invalid,
					'is-valid': dateFin.dirty && dateFin.valid
				}"
			/>
		</div>
	</div>

	<div class="row">
		<span class="theme-main-color fs-4 col">Durée d'exécution</span>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('periode')" class="col-12 col-lg">
			<label for="periode" class="form-label fw-bold"
				>Période d'exécution (en mois)</label
			>
			<input
				required
				type="number"
				min="1"
				class="form-control"
				formControlName="periode"
				placeholder="En jours"
			/>
		</div>

		<div *ngIf="form.contains('duree')" class="col-12 col-lg">
			<label for="duree" class="form-label fw-bold"
				>Durée (en heures)</label
			>
			<input
				required
				type="number"
				min="1"
				class="form-control"
				formControlName="duree"
				placeholder="En heures"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div *ngIf="form.contains('dureePrevisionnelle')" class="col-12 col-lg-6">
			<label for="dureePrevisionnelle" class="form-label fw-bold"
				>Durée prévisionnelle (en heures)</label
			>
			<input
				required
				type="number"
				min="1"
				class="form-control"
				formControlName="dureePrevisionnelle"
				placeholder="En heures"
			/>
		</div>
	</div>

	<div class="row my-4">
		<div class="col-12 col-lg">
			<label for="intervenant" class="form-label fw-bold"
				>Intervenant</label
			>
			<select
				id="intervenant"
				class="form-select"
				name="intervenant"
				formControlName="intervenant"
				aria-label="Sélectionner un intervenant"
				>
				<option *ngFor="let intervenant of listIntervenant |  orderBy:'lastName'" value="{{ intervenant.id }}">
					{{ intervenant.lastName +' ' + intervenant.firstName}}   | 
					<span
							*ngFor="let exp of intervenant.expertises; let ilast = last"
							class="me-1"
						>
							{{ exp && ' ' + exp.name }}{{ exp && (ilast ? '' : ',') }}
						</span>
				</option>
			</select>
		</div>
	</div>
	<!-- <div class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				[disabled]="this.disableChooseEmployeeButton()"
				class="btn theme-green-button"
				type="button"
				(click)="openModalChooseEmployee()"
				>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Choisir un intervenant
			</button>
		</div>
	</div>
	<app-prestation-modal-choose-intervenant *ngIf="showModal"
					[selectedAddress]="selectedAddress"
					[selectedExpertises]="selectedExpertises"
					[selectedTypePrestation]="selectedTypePrestation"
					(sendForm)="submitForm()"
					(hideModal)="bsModalRef.hide()"
					[isValidateButtonClicked]="isValidateButtonClicked"
	></app-prestation-modal-choose-intervenant> -->
	<accordion-group heading="Gestion opérationnelle" [isOpen]="false" *ngIf="this.isIntervenant" style="font-size: small;">
		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Motivation et objectifs</span>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('raisonDemandeAccomp')" class="col-12 col-lg">
				<label for="raisonDemandeAccomp" class="form-label fw-bold"
					>Raisons de la demande d'accompagnement auprès de l'AGEFIPH</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorRaisonDemandeAccomp"> </ngx-editor-menu>
					<ngx-editor [editor]="editorRaisonDemandeAccomp" formControlName="raisonDemandeAccomp"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected  && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('objectifPro')" class="col-12 col-lg">
				<label for="objectifPro" class="form-label fw-bold"
					>Objectifs professionnels visés</label
				>
				<select
					id="objectifPro"
					class="form-select"
					name="objectifPro"
					formControlName="objectifPro"
					>
					<option *ngFor="let objectifPro of listObjectifPro" value="{{ objectifPro.id }}">
						{{ objectifPro.name}}
					</option>
				</select>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Antécédant avec le prescripteur</span>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('typeAccompagnement')" class="col-12 col-lg">
				<label for="typeAccompagnement" class="form-label fw-bold"
					>Type d'accompagnement</label
				>
				<input
					id="typeAccompagnement"
					class="form-control"
					formControlName="typeAccompagnement"
				/>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('difficultes')" class="col-12 col-lg">
				<label for="difficultes" class="form-label fw-bold"
					>Difficultés rencontrées</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDifficultes"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDifficultes" formControlName="difficultes"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('besoins')" class="col-12 col-lg-12">
				<label for="besoins" class="form-label fw-bold"
					>Besoins exprimés</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorBesoins"> </ngx-editor-menu>
					<ngx-editor [editor]="editorBesoins" formControlName="besoins"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Situation actuelle</span>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label class="form-label fw-bold"
					>Statut professionnel actuel</label
				>
				<select
					id="statutProfessionnel"
					class="form-select"
					name="statutProfessionnel"
					formControlName="statutProfessionnel"
					>
					<option *ngFor="let statutProfessionnel of listStatutProfessionnel" value="{{ statutProfessionnel.id }}">
						{{ statutProfessionnel.name }}
					</option>
				</select>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Situation vis à vis du handicap</span>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label class="form-label fw-bold"
					>Titre du bénéficiaire de l’obligation d’emploi</label
				>
				<select
					id="tauxReconnaissance"
					class="form-select"
					name="tauxReconnaissance"
					formControlName="tauxReconnaissance"
					>
					<option *ngFor="let tauxReconnaissance of listTauxReconnaissance" value="{{ tauxReconnaissance.id }}">
						{{ tauxReconnaissance.name }}
					</option>
				</select>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="origineHandicap" class="form-label fw-bold"
					>Origine de l'handicap</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorOrigineHandicap"> </ngx-editor-menu>
					<ngx-editor [editor]="editorOrigineHandicap" formControlName="origineHandicap"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="doleances" class="form-label fw-bold"
					>Doléances</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDoleances"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDoleances" formControlName="doleances"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="rapportHandicap" class="form-label fw-bold"
					>Rapport à l'handicap</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorRapportHandicap"> </ngx-editor-menu>
					<ngx-editor [editor]="editorRapportHandicap" formControlName="rapportHandicap"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label class="form-label fw-bold"
					>Niveau de qualification professionnelle</label
				>
				<select
					id="niveauEtude"
					class="form-select"
					name="niveauEtude"
					formControlName="niveauEtude"
					>
					<option *ngFor="let niveauEtude of listNiveauEtude" value="{{ niveauEtude.id }}">
						{{ niveauEtude.name }}
					</option>
				</select>
			</div>
		</div>

		<div *ngIf="(this.isQDSelected || this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label class="form-label fw-bold"
					>Situation professionnelle au moment du dépôt de la demande</label
				>
				<select
					id="statutProfessionnel"
					class="form-select"
					name="statutProfessionnel"
					formControlName="statutProfessionnel"
					(ngModelChange)="onStatutProChanged()"
					>
					<option *ngFor="let statutProfessionnel of listStatutProfessionnel" value="{{ statutProfessionnel.id }}">
						{{ statutProfessionnel.name }}
					</option>
				</select>
			</div>
		</div>

		<div class="row my-4" *ngIf="!this.isSPSelected">
			<div *ngIf="this.showFieldDateDebutContrat" class="col-12 col-lg">
				<label for="dateDebutContrat" class="form-label fw-bold"
					>Date de début de contrat</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="dateDebutContrat"
					name="dateDebutContrat"
					formControlName="dateDebutContrat"
					[ngClass]="{
						'is-invalid': dateDebutContrat.invalid,
						'is-valid': dateDebutContrat.dirty && dateDebutContrat.valid
					}"
				/>
			</div>
			<div *ngIf="this.showFieldDateFinContrat" class="col-12 col-lg-6">
				<label for="dateFinContrat" class="form-label fw-bold"
					>Date de fin de contrat</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="dateFinContrat"
					name="dateFinContrat"
					formControlName="dateFinContrat"
					[ngClass]="{
						'is-invalid': dateFinContrat.invalid,
						'is-valid': dateFinContrat.dirty && dateFinContrat.valid
					}"
				/>
			</div>
		</div>

		<div class="row my-4" *ngIf="!this.isSPSelected">
			<div *ngIf="form.contains('salarieEntreprise')" class="col-12 col-lg">
				<label for="salarieEntreprise" class="form-label fw-bold"
					>Le bénéficiaire est-il salarié de l'entreprise déposante :</label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="salarieEntreprise" formControlName="salarieEntreprise" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="salarieEntreprise" formControlName="salarieEntreprise" [value]="false" />Non
				</label>
			</div>
		</div>

		<div class="row my-4" *ngIf="!this.isSPSelected">
			<div *ngIf="form.contains('accordEmployeur')" class="col-12 col-lg">
				<label for="accordEmployeur" class="form-label fw-bold"
					>Est-ce que l'employeur a donné son accord pour ce service :</label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="accordEmployeur" formControlName="accordEmployeur" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="accordEmployeur" formControlName="accordEmployeur" [value]="false" />Non
				</label>
			</div>
		</div>

		<div class="row my-4" *ngIf="!this.isSPSelected">
			<div *ngIf="form.contains('arretTravail')" class="col-12 col-lg">
				<label for="arretTravail" class="form-label fw-bold"
					>Est-ce que le bénéficiaire est en arrêt de travail:</label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="arretTravail" formControlName="arretTravail" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="arretTravail" formControlName="arretTravail" [value]="false" />Non
				</label>
			</div>
		</div>

		<div class="row my-4" *ngIf="!this.isSPSelected">
			<div *ngIf="form.contains('agentFonctPub')" class="col-12 col-lg">
				<label for="agentFonctPub" class="form-label fw-bold"
					>Est-ce que le bénéficiaire est agent ou contractuel de la fonction publique :</label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="agentFonctPub" formControlName="agentFonctPub" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="agentFonctPub" formControlName="agentFonctPub" [value]="false" />Non
				</label>
			</div>
		</div>

		<div class="row my-4" *ngIf="!this.isSPSelected">
			<div *ngIf="form.contains('accordHandicap')" class="col-12 col-lg">
				<label for="accordHandicap" class="form-label fw-bold"
					>Est-ce que l'entreprise dispose d'un accord agréé pour l'emploi des travailleurs handicapés:</label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="accordHandicap" formControlName="accordHandicap" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="accordHandicap" formControlName="accordHandicap" [value]="false" />Non
				</label>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Situation sociale</span>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('logement')" class="col-12 col-lg">
				<label for="logement" class="form-label fw-bold"
					>Logement</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorLogement"> </ngx-editor-menu>
					<ngx-editor [editor]="editorLogement" formControlName="logement"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('sante')" class="col-12 col-lg">
				<label for="sante" class="form-label fw-bold"
					>Santé</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSante"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSante" formControlName="sante"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('situationFinanciere')" class="col-12 col-lg">
				<label for="situationFinanciere" class="form-label fw-bold"
					>Situation financière</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSituationFinanciere"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSituationFinanciere" formControlName="situationFinanciere"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('situationFamiliale')" class="col-12 col-lg">
				<label for="situationFamiliale" class="form-label fw-bold"
					>Situation familiale</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSituationFamiliale"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSituationFamiliale" formControlName="situationFamiliale"></ngx-editor>
				</div>
			</div>
		</div>


		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Situation médicale</span>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('smBilan')" class="col-12 col-lg">
				<label for="smBilan" class="form-label fw-bold"
					>Bilans réalisés</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSmBilan"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSmBilan" formControlName="smBilan"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('smAccomp')" class="col-12 col-lg">
				<label for="smAccomp" class="form-label fw-bold"
					>Accompagnement en cours</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSmAccomp"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSmAccomp" formControlName="smAccomp"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Besoins identifiés</span>
		</div>

		<!-- <div *ngIf="this.isQDSelected && this.isStatutDESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('deMetiersCibles')" class="col-12 col-lg">
				<label for="deMetiersCibles" class="form-label fw-bold"
					>Métier ciblé - Secteur d'activité</label
				>
				<input
					id="deMetiersCibles"
					class="form-control"
					formControlName="deMetiersCibles"
				/>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutDESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('deProjetPro')" class="col-12 col-lg">
				<label for="deProjetPro" class="form-label fw-bold"
					>Projet professionnel</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDeProjetPro"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDeProjetPro" formControlName="deProjetPro"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutDESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('deRuptureParcours')" class="col-12 col-lg">
				<label for="deRuptureParcours" class="form-label fw-bold"
					>Ruptures de parcours</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDeRuptureParcours"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDeRuptureParcours" formControlName="deRuptureParcours"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutDESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('deBesoinsIdent')" class="col-12 col-lg">
				<label for="deBesoinsIdent" class="form-label fw-bold"
					>Besoins déjà identifiés</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDeBesoinsIdent"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDeBesoinsIdent" formControlName="deBesoinsIdent"></ngx-editor>
				</div>
			</div>
		</div> -->

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeLimites')" class="col-12 col-lg">
				<label for="eeLimites" class="form-label fw-bold"
					>Limites et capacités</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeLimites"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeLimites" formControlName="eeLimites"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeQuestEmploi')" class="col-12 col-lg">
				<label for="eeQuestEmploi" class="form-label fw-bold"
					>Questions au regard de l'emploi</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeQuestEmploi"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeQuestEmploi" formControlName="eeQuestEmploi"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeBesoinsAdapt')" class="col-12 col-lg">
				<label for="eeBesoinsAdapt" class="form-label fw-bold"
					>Besoin d'adaptation</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeBesoinsAdapt"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeBesoinsAdapt" formControlName="eeBesoinsAdapt"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eePbAccess')" class="col-12 col-lg">
				<label for="eePbAccess" class="form-label fw-bold"
					>Problème d'accessibilité</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEePbAccess"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEePbAccess" formControlName="eePbAccess"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeAccompDejaMene')" class="col-12 col-lg">
				<label for="eeAccompDejaMene" class="form-label fw-bold"
					>Actions d’accompagnement déjà menées</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeAccompDejaMene"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeAccompDejaMene" formControlName="eeAccompDejaMene"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeNomEntreprise')" class="col-12 col-lg">
				<label for="eeNomEntreprise" class="form-label fw-bold"
					>Nom de l'entreprise</label
				>
				<input
					id="eeNomEntreprise"
					class="form-control"
					formControlName="eeNomEntreprise"
				/>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeNomContactEntreprise')" class="col-12 col-lg">
				<label for="eeNomContactEntreprise" class="form-label fw-bold"
					>Nom du contact entreprise</label
				>
				<input
					id="eeNomContactEntreprise"
					class="form-control"
					formControlName="eeNomContactEntreprise"
				/>
			</div>
			<div *ngIf="form.contains('eePrenomContactEntreprise')" class="col-12 col-lg">
				<label for="eePrenomContactEntreprise" class="form-label fw-bold"
					>Prénom du contact entreprise</label
				>
				<input
					id="eePrenomContactEntreprise"
					class="form-control"
					formControlName="eePrenomContactEntreprise"
				/>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeMailContactEntreprise')" class="col-12 col-lg">
				<label for="eeMailContactEntreprise" class="form-label fw-bold"
					>Mail du contact entreprise</label
				>
				<input
					id="eeMailContactEntreprise"
					class="form-control"
					formControlName="eeMailContactEntreprise"
				/>
			</div>
			<div *ngIf="form.contains('eeTelContactEntreprise')" class="col-12 col-lg">
				<label for="eeTelContactEntreprise" class="form-label fw-bold"
					>Téléphone du contact entreprise</label
				>
				<input
					id="eeTelContactEntreprise"
					class="form-control"
					formControlName="eeTelContactEntreprise"
				/>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeSyntheseSitEmployeur')" class="col-12 col-lg">
				<label for="eeSyntheseSitEmployeur" class="form-label fw-bold"
					>Synthèse de la situation par l'employeur</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeSyntheseSitEmployeur"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeSyntheseSitEmployeur" formControlName="eeSyntheseSitEmployeur"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeHoraires')" class="col-12 col-lg">
				<label for="eeHoraires" class="form-label fw-bold"
					>Horaires</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeHoraires"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeHoraires" formControlName="eeHoraires"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEESelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('eeFichePoste')" class="col-12 col-lg">
				<label for="eeFichePoste" class="form-label fw-bold"
					>Fiche de poste</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEeFichePoste"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEeFichePoste" formControlName="eeFichePoste"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efLimiteCapacite')" class="col-12 col-lg">
				<label for="efLimiteCapacite" class="form-label fw-bold"
					>Limites et capacités</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfLimiteCapacite"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfLimiteCapacite" formControlName="efLimiteCapacite"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efQuestionnement')" class="col-12 col-lg">
				<label for="efQuestionnement" class="form-label fw-bold"
					>Questionnement</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfQuestionnement"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfQuestionnement" formControlName="efQuestionnement"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efAccompDejaMene')" class="col-12 col-lg">
				<label for="efAccompDejaMene" class="form-label fw-bold"
					>Actions d’accompagnement déjà menées</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfAccompDejaMene"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfAccompDejaMene" formControlName="efAccompDejaMene"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efAccessibilite')" class="col-12 col-lg">
				<label for="efAccessibilite" class="form-label fw-bold"
					>Accessibilité et/ou de compensation</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfAccessibilite"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfAccessibilite" formControlName="efAccessibilite"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('typeFormation')" class="col-12 col-lg">
				<label for="typeFormation" class="form-label fw-bold"
					>Type de formation</label
				>
				<select
					id="typeFormation"
					class="form-select"
					name="typeFormation"
					formControlName="typeFormation"
					>
					<option *ngFor="let typeFormation of listTypeFormation" value="{{ typeFormation.id }}">
						{{ typeFormation.name}}
					</option>
				</select>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efBesoinsAt')" class="col-12 col-lg">
				<label for="efBesoinsAt" class="form-label fw-bold"
					>Besoins en AT</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfBesoinsAt"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfBesoinsAt" formControlName="efBesoinsAt"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efNomCentreFormation')" class="col-12 col-lg">
				<label for="efNomCentreFormation" class="form-label fw-bold"
					>Nom du centre de formation et référent handicap</label
				>
				<input
					id="efNomCentreFormation"
					class="form-control"
					formControlName="efNomCentreFormation"
				/>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efPlanning')" class="col-12 col-lg">
				<label for="efPlanning" class="form-label fw-bold"
					>Planning</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfPlanning"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfPlanning" formControlName="efPlanning"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isStatutEFSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('efRemarqueRef')" class="col-12 col-lg">
				<label for="efRemarqueRef" class="form-label fw-bold"
					>Remarque référent</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorEfRemarqueRef"> </ngx-editor-menu>
					<ngx-editor [editor]="editorEfRemarqueRef" formControlName="efRemarqueRef"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Suivi</span>
		</div>

		<!-- <div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="datePrescription" class="form-label fw-bold"
					>Date de prescription</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="datePrescription"
					name="datePrescription"
					formControlName="datePrescription"
					[ngClass]="{
						'is-invalid': datePrescription.invalid,
						'is-valid': datePrescription.dirty && datePrescription.valid
					}"
				/>
			</div>
			<div class="col-12 col-lg">
				<label for="datePremierContact" class="form-label fw-bold"
				>Date du premier contact</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="datePremierContact"
				name="datePremierContact"
				formControlName="datePremierContact"
				[ngClass]="{
					'is-invalid': datePremierContact.invalid,
					'is-valid': datePremierContact.dirty && datePremierContact.valid
				}"
			/>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && form.contains('datePremierRv') && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg-6">
				<label for="datePremierRv" class="form-label fw-bold"
					>Date du premier rendez-vous</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="datePremierRv"
					name="datePremierRv"
					formControlName="datePremierRv"
					[ngClass]="{
						'is-invalid': datePremierRv.invalid,
						'is-valid': datePremierRv.dirty && datePremierRv.valid
					}"
				/>
			</div>
			<div class="col-12 col-lg-6">
				<label for="dateS3" class="form-label fw-bold"
				>Date du suivi à 3 mois</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateS3"
				name="dateS3"
				formControlName="dateS3"
				[ngClass]="{
					'is-invalid': dateS3.invalid,
					'is-valid': dateS3.dirty && dateS3.valid
				}"
			/>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && form.contains('dateS6') && this.isIntervenant" class="col-12 col-lg-6">
			<label for="dateS6" class="form-label fw-bold"
				>Date du suivi à 6 mois</label
			>
			<input
				autocomplete="off"
				type="text"
				class="form-control"
				bsDatepicker
				id="dateS6"
				name="dateS6"
				formControlName="dateS6"
				[ngClass]="{
					'is-invalid': dateS6.invalid,
					'is-valid': dateS6.dirty && dateS6.valid
				}"
			/>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('preconisationsProposes')" class="col-12 col-lg">
				<label for="preconisationsProposes" class="form-label fw-bold"
					>Préconisations proposées</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPreconisationsProposes"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPreconisationsProposes" formControlName="preconisationsProposes"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant">
			<div
				*ngIf="form.contains('comprehensionPreco')"
				class="form-check form-switch ms-2"
			>
				<input
					class="form-check-input theme-main-border-color"
					type="checkbox"
					id="comprehensionPreco"
					formControlName="comprehensionPreco"
					[ngClass]="{
						'theme-main-color-check': comprehensionPreco.value
					}"
				/>
				<label class="form-check-label text-dark" for="comprehensionPreco"
					>Compréhension des préconisations</label
				>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('description')" class="col-12 col-lg">
				<label for="description" class="form-label fw-bold"
					>Description</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDescription"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDescription" formControlName="description"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('complements')" class="col-12 col-lg">
				<label for="complements" class="form-label fw-bold"
					>Compléments d'information</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorComplements"> </ngx-editor-menu>
					<ngx-editor [editor]="editorComplements" formControlName="complements"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Suivi à 3 mois</span>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('nomS3')" class="col-12 col-lg">
				<label for="nomS3" class="form-label fw-bold"
					>Nom de la personne contactée</label
				>
				<input
					id="nomS3"
					class="form-control"
					formControlName="nomS3"
				/>
			</div>
			<div *ngIf="form.contains('prenomS3')" class="col-12 col-lg">
				<label for="prenomS3" class="form-label fw-bold"
					>Prénom de la personne contactée</label
				>
				<input
					id="prenomS3"
					class="form-control"
					formControlName="prenomS3"
				/>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('fonctionS3')" class="col-12 col-lg">
				<label for="fonctionS3" class="form-label fw-bold"
					>Fonction de la personne contactée</label
				>
				<input
					id="fonctionS3"
					class="form-control"
					formControlName="fonctionS3"
				/>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant">
			<div
				*ngIf="form.contains('preconisationMeoS3')"
				class="form-check form-switch ms-2"
			>
				<input
					class="form-check-input theme-main-border-color"
					type="checkbox"
					id="preconisationMeoS3"
					formControlName="preconisationMeoS3"
					[ngClass]="{
						'theme-main-color-check': preconisationMeoS3.value
					}"
				/>
				<label class="form-check-label text-dark" for="preconisationMeoS3"
					>Préconisations mises en oeuvre</label
				>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('descriptionS3')" class="col-12 col-lg">
				<label for="descriptionS3" class="form-label fw-bold"
					>Description</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDescriptionS3"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDescriptionS3" formControlName="descriptionS3"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('freinS3')" class="col-12 col-lg">
				<label for="freinS3" class="form-label fw-bold"
					>Frein</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorFreinS3"> </ngx-editor-menu>
					<ngx-editor [editor]="editorFreinS3" formControlName="freinS3"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('reponseS3')" class="col-12 col-lg">
				<label for="reponseS3" class="form-label fw-bold"
					>Réponse apportée</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorReponseS3"> </ngx-editor-menu>
					<ngx-editor [editor]="editorReponseS3" formControlName="reponseS3"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Suivi à 6 mois</span>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('nomS6')" class="col-12 col-lg">
				<label for="nomS6" class="form-label fw-bold"
					>Nom de la personne contactée</label
				>
				<input
					id="nomS6"
					class="form-control"
					formControlName="nomS6"
				/>
			</div>
			<div *ngIf="form.contains('prenomS6')" class="col-12 col-lg">
				<label for="prenomS6" class="form-label fw-bold"
					>Prénom de la personne contactée</label
				>
				<input
					id="prenomS6"
					class="form-control"
					formControlName="prenomS6"
				/>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('fonctionS6')" class="col-12 col-lg">
				<label for="fonctionS6" class="form-label fw-bold"
					>Fonction de la personne contactée</label
				>
				<input
					id="fonctionS6"
					class="form-control"
					formControlName="fonctionS6"
				/>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant">
			<div
				*ngIf="form.contains('preconisationMeoS6')"
				class="form-check form-switch ms-2"
			>
				<input
					class="form-check-input theme-main-border-color"
					type="checkbox"
					id="preconisationMeoS6"
					formControlName="preconisationMeoS6"
					[ngClass]="{
						'theme-main-color-check': preconisationMeoS6.value
					}"
				/>
				<label class="form-check-label text-dark" for="preconisationMeoS6"
					>Préconisations mises en oeuvre</label
				>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('descriptionS6')" class="col-12 col-lg">
				<label for="descriptionS6" class="form-label fw-bold"
					>Description</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorDescriptionS6"> </ngx-editor-menu>
					<ngx-editor [editor]="editorDescriptionS6" formControlName="descriptionS6"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('freinS6')" class="col-12 col-lg">
				<label for="freinS6" class="form-label fw-bold"
					>Frein</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorFreinS6"> </ngx-editor-menu>
					<ngx-editor [editor]="editorFreinS6" formControlName="freinS6"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('reponseS6')" class="col-12 col-lg">
				<label for="reponseS6" class="form-label fw-bold"
					>Réponse apportée</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorReponseS6"> </ngx-editor-menu>
					<ngx-editor [editor]="editorReponseS6" formControlName="reponseS6"></ngx-editor>
				</div>
			</div>
		</div> -->

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="dateContactPrescripteur" class="form-label fw-bold"
					>Date de contact - prescripteur</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="dateContactPrescripteur"
					name="dateContactPrescripteur"
					formControlName="dateContactPrescripteur"
					[ngClass]="{
						'is-invalid': dateContactPrescripteur.invalid,
						'is-valid': dateContactPrescripteur.dirty && dateContactPrescripteur.valid
					}"
				/>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="dateContactPersonne" class="form-label fw-bold"
					>Date de contact - personne</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="dateContactPersonne"
					name="dateContactPersonne"
					formControlName="dateContactPersonne"
					[ngClass]="{
						'is-invalid': dateContactPersonne.invalid,
						'is-valid': dateContactPersonne.dirty && dateContactPersonne.valid
					}"
				/>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="dateContactEmployeur" class="form-label fw-bold"
					>Date de contact - employeur</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="dateContactEmployeur"
					name="dateContactEmployeur"
					formControlName="dateContactEmployeur"
					[ngClass]="{
						'is-invalid': dateContactEmployeur.invalid,
						'is-valid': dateContactEmployeur.dirty && dateContactEmployeur.valid
					}"
				/>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="meoSolutions" class="form-label fw-bold"
					>Mise en oeuvre des solutions de compensation préconisées:   </label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="meoSolutions" formControlName="meoSolutions" value="oui" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="meoSolutions" formControlName="meoSolutions" value="ouiPartiellement" />Oui partiellement
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="meoSolutions" formControlName="meoSolutions" value="non" />Non
				</label>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('precoNonMeo')" class="col-12 col-lg">
				<label for="precoNonMeo" class="form-label fw-bold"
					>Préconisations non mises en oeuvre</label
				>
				<input
					id="precoNonMeo"
					class="form-control"
					formControlName="precoNonMeo"
				/>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('raisons')" class="col-12 col-lg">
				<label for="raisons" class="form-label fw-bold"
					>Pour quelles raisons</label
				>
				<input
					id="raisons"
					class="form-control"
					formControlName="raisons"
				/>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="propositionAs" class="form-label fw-bold"
					>Proposition au prescripteur d'un nouvel appui spécifique:   </label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="propositionAs" formControlName="propositionAs" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="propositionAs" formControlName="propositionAs" [value]="false" />Non
				</label>
			</div>
		</div>

		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="propositionAutre" class="form-label fw-bold"
					>Proposition au prescripteur d'une orientation vers un autre dispositif:   </label
				>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="propositionAutre" formControlName="propositionAutre" [value]="true" />Oui
				</label>
				<label class="ms-2 form-check-label text-dark">
					<input type="radio" name="propositionAutre" formControlName="propositionAutre" [value]="false" />Non
				</label>
			</div>
		</div>
		<div *ngIf="this.isSPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('propositionAutreDetails')" class="col-12 col-lg">
				<label for="propositionAutreDetails" class="form-label fw-bold"
					>Lequel</label
				>
				<input
					id="propositionAutreDetails"
					class="form-control"
					formControlName="propositionAutreDetails"
				/>
			</div>
		</div>
		<div class="row my-4" *ngIf="this.isSPSelected">
			<div class="col-12 col-lg">
				<label class="form-label fw-bold"
					>Heures saisies sur module</label
				>
				<input
					type="number"
					class="form-control"
					[disabled]="true"
				/>	
				
			</div>
		</div>
		<div class="row my-4" *ngIf="this.isSPSelected">
			<div class="col-12 col-lg">
				<label class="form-label fw-bold"
					>Date du dépôt de restitution finale</label
				>
				<input
					type="number"
					class="form-control"
					[disabled]="true"
				/>	
				
			</div>
		</div>
		<div class="row my-4" *ngIf="this.isSPSelected">
			<div *ngIf="form.contains('dateFin')" class="col-12 col-lg-6">
				<label for="dateFin" class="form-label fw-bold"
					>Date de fin du suivi des préconisations</label
				>
				<input
					autocomplete="off"
					type="text"
					class="form-control"
					bsDatepicker
					id="dateFin"
					name="dateFin"
					formControlName="dateFin"
					[ngClass]="{
						'is-invalid': dateFin.invalid,
						'is-valid': dateFin.dirty && dateFin.valid
					}"
				/>
			</div>
		</div>
		<div class="row my-4" *ngIf="this.isSPSelected">
			<div class="col-12 col-lg">
				<label for="heuresDeclarees" class="form-label fw-bold"
					>Quantité déclarée totale</label
				>
				<input
					type="number"
					class="form-control"
					formControlName="heuresDeclarees"
					placeholder="En heures"
				/>	
				
			</div>
		</div>

		<!-- <div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('orientationMdph')" class="col-12 col-lg-12">
				<label for="orientationMdph" class="form-label fw-bold"
					>Orientation proposées par la MDPH</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorOrientationMdph"> </ngx-editor-menu>
					<ngx-editor [editor]="editorOrientationMdph" formControlName="orientationMdph"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isASSelected" class="row">
			<span class="theme-main-color fs-4 col">Analyse</span>
		</div>

		<div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('competenceProPerso')" class="col-12 col-lg">
				<label for="competenceProPerso" class="form-label fw-bold"
					>Compétences professionnelles et personnelles identifiées</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorCompetenceProPerso"> </ngx-editor-menu>
					<ngx-editor [editor]="editorCompetenceProPerso" formControlName="competenceProPerso"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('freins')" class="col-12 col-lg">
				<label for="freins" class="form-label fw-bold"
					>Freins à l'emploi ou à la formation identifiés</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorFreins"> </ngx-editor-menu>
					<ngx-editor [editor]="editorFreins" formControlName="freins"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('ressources')" class="col-12 col-lg">
				<label for="ressources" class="form-label fw-bold"
					>Ressources et atouts de la personne en situation de handicap</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorRessources"> </ngx-editor-menu>
					<ngx-editor [editor]="editorRessources" formControlName="ressources"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('contraintes')" class="col-12 col-lg">
				<label for="contraintes" class="form-label fw-bold"
					>Spécificités et contraintes liées au handicap</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorContraintes"> </ngx-editor-menu>
					<ngx-editor [editor]="editorContraintes" formControlName="contraintes"></ngx-editor>
				</div>
			</div>
		</div> -->
		<div *ngIf="this.isACSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Conclusion du bilan</span>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('ressourcesFinancieres')" class="col-12 col-lg">
				<label for="ressourcesFinancieres" class="form-label fw-bold"
					>Ressources financières</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorRessourcesFinancieres"> </ngx-editor-menu>
					<ngx-editor [editor]="editorRessourcesFinancieres" formControlName="ressourcesFinancieres"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('niveauRendement')" class="col-12 col-lg">
				<label for="niveauRendement" class="form-label fw-bold"
					>Niveau de rendement occupationnel</label
				>
				<input
					id="niveauRendement"
					class="form-control"
					formControlName="niveauRendement"
				/>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('satisfaction')" class="col-12 col-lg">
				<label for="satisfaction" class="form-label fw-bold"
					>Satisfaction</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSatisfaction"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSatisfaction" formControlName="satisfaction"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('stress')" class="col-12 col-lg">
				<label for="stress" class="form-label fw-bold"
					>Stress</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorStress"> </ngx-editor-menu>
					<ngx-editor [editor]="editorStress" formControlName="stress"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('forces')" class="col-12 col-lg">
				<label for="forces" class="form-label fw-bold"
					>Forces et Points de vigilance identifié par la personne</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorForces"> </ngx-editor-menu>
					<ngx-editor [editor]="editorForces" formControlName="forces"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Projet professionnel</span>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('ppIntitulePoste')" class="col-12 col-lg">
				<label for="ppIntitulePoste" class="form-label fw-bold"
					>Intitulé poste/formation visé</label
				>
				<input
					id="ppIntitulePoste"
					class="form-control"
					formControlName="ppIntitulePoste"
				/>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('ppDescriptionPosteBenef')" class="col-12 col-lg">
				<label for="ppDescriptionPosteBenef" class="form-label fw-bold"
					>Description poste/formation selon le bénéficiaire</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPpDescriptionPosteBenef"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPpDescriptionPosteBenef" formControlName="ppDescriptionPosteBenef"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('ppDescriptionPosteOf')" class="col-12 col-lg">
				<label for="ppDescriptionPosteOf" class="form-label fw-bold"
					>Description poste/formation selon OF ou fiche de poste</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPpDescriptionPosteOf"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPpDescriptionPosteOf" formControlName="ppDescriptionPosteOf"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('ppEntrepriseVise')" class="col-12 col-lg">
				<label for="ppEntrepriseVise" class="form-label fw-bold"
					>Centre de formation / Entreprise visé</label
				>
				<input
					id="ppEntrepriseVise"
					class="form-control"
					formControlName="ppEntrepriseVise"
				/>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Evaluation neuropsychologique</span>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Exigences fonctionnelles liées au poste visé</span>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('attention')" class="col-12 col-lg">
				<label for="attention" class="form-label fw-bold"
					>Attention</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorAttention"> </ngx-editor-menu>
					<ngx-editor [editor]="editorAttention" formControlName="attention"></ngx-editor>
				</div>
			</div>
		</div>


		<div *ngIf="(this.isASSelected || this.isEAPSelected || this.isACSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('langage')" class="col-12 col-lg">
				<label for="langage" class="form-label fw-bold"
					>Langage</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorLangage"> </ngx-editor-menu>
					<ngx-editor [editor]="editorLangage" formControlName="langage"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected || this.isACSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('praxie')" class="col-12 col-lg">
				<label for="praxie" class="form-label fw-bold"
					>Praxie</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPraxie"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPraxie" formControlName="praxie"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('gnosies')" class="col-12 col-lg">
				<label for="gnosies" class="form-label fw-bold"
					>Gnosies</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorGnosies"> </ngx-editor-menu>
					<ngx-editor [editor]="editorGnosies" formControlName="gnosies"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected || this.isACSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('memoire')" class="col-12 col-lg">
				<label for="memoire" class="form-label fw-bold"
					>Mémoire</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorMemoire"> </ngx-editor-menu>
					<ngx-editor [editor]="editorMemoire" formControlName="memoire"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected || this.isACSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('fonctExecutif')" class="col-12 col-lg">
				<label for="fonctExecutif" class="form-label fw-bold"
					>Fonctionnement exécutif</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorFonctExecutif"> </ngx-editor-menu>
					<ngx-editor [editor]="editorFonctExecutif" formControlName="fonctExecutif"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('pointVigilence')" class="col-12 col-lg">
				<label for="pointVigilence" class="form-label fw-bold"
					>Points de vigilance entre les exigences fonctionnelles et les aptitudes de la personne</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPointVigilence"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPointVigilence" formControlName="pointVigilence"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('fonctAttent')" class="col-12 col-lg">
				<label for="fonctAttent" class="form-label fw-bold"
					>Fonctions attentionnelles</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorFonctAttent"> </ngx-editor-menu>
					<ngx-editor [editor]="editorFonctAttent" formControlName="fonctAttent"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('cognitionSociale')" class="col-12 col-lg">
				<label for="cognitionSociale" class="form-label fw-bold"
					>Cognition sociale</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorCognitionSociale"> </ngx-editor-menu>
					<ngx-editor [editor]="editorCognitionSociale" formControlName="cognitionSociale"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isASSelected || this.isEAPSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('comportement')" class="col-12 col-lg">
				<label for="comportement" class="form-label fw-bold"
					>Comportement</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorComportement"> </ngx-editor-menu>
					<ngx-editor [editor]="editorComportement" formControlName="comportement"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="(this.isEAPSelected || this.isACSelected) && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('preconisations')" class="col-12 col-lg">
				<label for="preconisations" class="form-label fw-bold"
					>Préconisations</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPreconisations"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPreconisations" formControlName="preconisations"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isEAPSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('observations')" class="col-12 col-lg">
				<label for="observations" class="form-label fw-bold"
					>Observations</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorObservations"> </ngx-editor-menu>
					<ngx-editor [editor]="editorObservations" formControlName="observations"></ngx-editor>
				</div>
			</div>
		</div>

		<!-- <div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('propositionsActions')" class="col-12 col-lg">
				<label for="propositionsActions" class="form-label fw-bold"
					>Propositions d'actions</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPropositionsActions"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPropositionsActions" formControlName="propositionsActions"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isASSelected" class="row my-4">
			<div *ngIf="form.contains('planActionPerso')" class="col-12 col-lg">
				<label for="planActionPerso" class="form-label fw-bold"
					>Plan d'action personnalisé</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPlanActionPerso"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPlanActionPerso" formControlName="planActionPerso"></ngx-editor>
				</div>
			</div>
		</div> -->

		<!-- <div *ngIf="this.isACSelected" class="row my-4">
			<div *ngIf="form.contains('metiersCibles')" class="col-12 col-lg-12">
				<label for="metiersCibles" class="form-label fw-bold"
					>Métier ciblé</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorMetiersCibles"> </ngx-editor-menu>
					<ngx-editor [editor]="editorMetiersCibles" formControlName="metiersCibles"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected" class="row my-4">
			<div *ngIf="form.contains('analyseAdequation')" class="col-12 col-lg">
				<label for="analyseAdequation" class="form-label fw-bold"
					>Analyse de l'adéquation entre les capacités de la personne et les exigences du métier</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorAnalyseAdequation"> </ngx-editor-menu>
					<ngx-editor [editor]="editorAnalyseAdequation" formControlName="analyseAdequation"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isACSelected" class="row my-4">
			<div *ngIf="form.contains('recommandantions')" class="col-12 col-lg">
				<label for="recommandantions" class="form-label fw-bold"
					>Recommandations</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorRecommandantions"> </ngx-editor-menu>
					<ngx-editor [editor]="editorRecommandantions" formControlName="recommandantions"></ngx-editor>
				</div>
			</div>
		</div> -->

		<!-- <div *ngIf="this.isACSelected" class="row my-4">
			<div *ngIf="form.contains('planActionPerso')" class="col-12 col-lg">
				<label for="planActionPerso" class="form-label fw-bold"
					>Plan d'action personnalisé</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPlanActionPerso"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPlanActionPerso" formControlName="planActionPerso"></ngx-editor>
				</div>
			</div>
		</div> -->

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row">
			<span class="theme-main-color fs-4 col">Conclusions</span>
		</div>

		<div *ngIf="this.isIntervenant && !this.isSPSelected" class="row my-4">
			<div *ngIf="form.contains('syntheseInfo')" class="col-12 col-lg">
				<label for="syntheseInfo" class="form-label fw-bold"
					>Synthèse des informations recueillies lors de l'entretien initial</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorSyntheseInfo"> </ngx-editor-menu>
					<ngx-editor [editor]="editorSyntheseInfo" formControlName="syntheseInfo"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div *ngIf="form.contains('premieresOrientations')" class="col-12 col-lg">
				<label for="premieresOrientations" class="form-label fw-bold"
					>Premières orientations envisagées en termes de prestations ou de dispositifs d'accompagnement</label
				>
				<div class="NgxEditor__Wrapper">
					<ngx-editor-menu [editor]="editorPremieresOrientations"> </ngx-editor-menu>
					<ngx-editor [editor]="editorPremieresOrientations" formControlName="premieresOrientations"></ngx-editor>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant" class="row my-4">
			<div class="col-12 col-lg">
				<label for="dateFin" class="form-label fw-bold"
					>Actions envisagées :</label
				>
				<div class="row">
					<div
						class="col-md-4 check"
						*ngFor="let module of listModuleEnum | keyvalue"
					>
						<div>
							<input
								type="checkbox"
								name="{{ module.value }}"
								class="form-check-input"
								[value]="module.key"
								[checked]="isModuleCheck(module.key)"
								[ngClass]="{
									'theme-main-color-check': isModuleCheck(module.key)
								}"
								(change)="updateSelectedModule($event, module.key)"
								[disabled]="isModuleDisabled(module.key)"
							/>
							<label class="ms-2 form-check-label text-dark">
								{{ PrestationTypeStringEnum[module.value] }}
							</label>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="this.isQDSelected && this.isIntervenant && this.showFieldModuleEmployee" class="row my-4">
			<div class="col-12 col-lg">
				<label for="intervenantModule" class="form-label fw-bold"
					>Intervenant</label
				>
				<select
					id="intervenantModule"
					class="form-select"
					name="intervenantModule"
					formControlName="intervenantModule"
					aria-label="Sélectionner un intervenant"
					>
					<option *ngFor="let intervenantModule of listIntervenant |  orderBy:'lastName'" value="{{ intervenantModule.id }}">
						{{ intervenantModule.lastName + ' ' +intervenantModule.firstName}}   | 
						<span
								*ngFor="let exp of intervenantModule.expertises; let ilast = last"
								class="me-1"
							>
								{{ exp && ' ' + exp.name }}{{ exp && (ilast ? '' : ',') }}
							</span>
					</option>
				</select>
			</div>
		</div>

	</accordion-group>

	<div *ngIf="isAddForm" class="row my-5">
		<div class="d-flex justify-content-end">
			<button
				class="btn theme-main-color-button mx-3 px-3"
				type="button"
				(click)="hideModal.emit()"
			>
				Retour
			</button>
			<button
				[disabled]="!form.valid || isValidateButtonClicked.value"
				class="btn theme-green-button"
				type="submit"
				form="form"
			>
				<i class="bi bi-save-fill px-1" aria-hidden="true"></i>Sauvegarder
			</button>
		</div>
	</div>
</form>
